import { createContext, useContext, useState, useEffect } from "react";

const STORAGE_KEY = "nateM_minimized";
const BREAKPOINT = 1280;
const NateMContext = createContext(null);

export const NATE_M_EXPANDED_WIDTH = 360;
// New Build 1 (Sep 18 2026): minimized state is now a small fixed-position pinned toggle button
// that floats over the page instead of reserving a strip of layout width — 0 here means it never
// pushes page content or the sidebar.
export const NATE_M_MINIMIZED_WIDTH = 0;

export function NateMProvider({ children }) {
  const [userPref, setUserPref] = useState(() => localStorage.getItem(STORAGE_KEY) === "true");
  const [narrow, setNarrow] = useState(() => window.innerWidth < BREAKPOINT);
  const [w9Gated, setW9Gated] = useState(false);

  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth < BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const minimized = narrow || userPref;

  const setMinimized = (val) => {
    setUserPref(val);
    localStorage.setItem(STORAGE_KEY, val ? "true" : "false");
  };

  return <NateMContext.Provider value={{ minimized, setMinimized, narrow, w9Gated, setW9Gated }}>{children}</NateMContext.Provider>;
}

export function useNateM() {
  const ctx = useContext(NateMContext);
  if (!ctx) throw new Error("useNateM must be used within NateMProvider");
  return ctx;
}
